import Cookie from "js-cookie";

export const clearStorage = () => {
  localStorage.removeItem("s-auth-user");
  Cookie.remove("s-auth-token");
  Cookie.set("mode", "LIVE");
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = "/login";
};

// AUTH TOKEN
export const getAuthToken = () => Cookie.get("s-auth-token");

export const setAuthToken = (token: string) =>
  Cookie.set("s-auth-token", token);

// COURSE REDIRECT
export const getCourseUrl = () => Cookie.get("s-course-url");

export const setCourseUrl = (token: string) =>
  Cookie.set("s-course-url", token);

export const setAuthUser = (user: any) =>
  localStorage.setItem("s-auth-user", JSON.stringify(user));

export const getAuthUser = () =>
  JSON.parse(localStorage.getItem("s-auth-user") as string);
